import $ from 'jquery';


export default () => {
  const fieldFocus = 'form-focus';
  let formInputs = $('input[type="email"],input[type="tel"],input[type="text"],input[type="password"]');
  $.map(formInputs, (input) => {
    if ($.trim($(input).val()).length > 0) {
      $(input).prev().addClass(fieldFocus);
    }
  })
  formInputs.focus(function() {
    $(this).prev().addClass(fieldFocus);
  });
  formInputs.focusout(function() {
    if ($.trim($(this).val()).length == 0){
      $(this).prev().removeClass(fieldFocus);
    }
  });
  formInputs.on('change', function(event) {
    $(this).prev().addClass(fieldFocus);
  });
  $('.top-bar-notifications__close-btn').on('click', function() {
    $(this).parent().parent().addClass('hide-animation').delay(100).addClass('hide');
  })
}